import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import { setUser, setError, setLoading } from "../store/slices/authSlice";
import { authService } from "../services/authService";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  const [tabValue, setTabValue] = useState(0);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    reset();
    dispatch(setError(null));
  };

  const onSubmit = async (data) => {
    dispatch(setLoading(true));
    dispatch(setError(null));

    try {
      let user;
      if (tabValue === 0) {
        // Login
        user = await authService.login(data.email, data.password);
      } else {
        // Registrazione
        user = await authService.register(
          data.email,
          data.password,
          data.displayName,
        );
      }

      const userData = await authService.getUserData(user.uid);
      dispatch(
        setUser({
          uid: user.uid,
          email: user.email,
          ...userData,
        }),
      );

      navigate("/");
    } catch (error) {
      dispatch(setError(error.message));
    }
  };

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: "100%" }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Sanremo 2026
          </Typography>

          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            centered
            sx={{ mb: 3 }}
          >
            <Tab label="Accedi" />
            <Tab label="Registrati" />
          </Tabs>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit(onSubmit)}>
            {tabValue === 1 && (
              <TextField
                fullWidth
                label="Nome"
                margin="normal"
                {...register("displayName", {
                  required: "Il nome è obbligatorio",
                  minLength: {
                    value: 2,
                    message: "Il nome deve essere di almeno 2 caratteri",
                  },
                })}
                error={!!errors.displayName}
                helperText={errors.displayName?.message}
              />
            )}

            <TextField
              fullWidth
              label="Email"
              type="email"
              margin="normal"
              {...register("email", {
                required: "L'email è obbligatoria",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Inserisci un'email valida",
                },
              })}
              error={!!errors.email}
              helperText={errors.email?.message}
            />

            <TextField
              fullWidth
              label="Password"
              type="password"
              margin="normal"
              {...register("password", {
                required: "La password è obbligatoria",
                minLength: {
                  value: 6,
                  message: "La password deve essere di almeno 6 caratteri",
                },
              })}
              error={!!errors.password}
              helperText={errors.password?.message}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} />
              ) : tabValue === 0 ? (
                "Accedi"
              ) : (
                "Registrati"
              )}
            </Button>
          </form>
        </Paper>
      </Box>
    </Box>
  );
};

export default Login;
